"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
function ErrorMessage(_a) {
    var errorMessage = _a.errorMessage;
    return (react_1.default.createElement(Box_1.default, { className: "error-message live-header", sx: { textAlign: 'left' } },
        react_1.default.createElement(Typography_1.default, { dangerouslySetInnerHTML: { __html: errorMessage } })));
}
exports.default = ErrorMessage;
